/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftTracker } from './NftTracker';
import {
    NftTrackerFromJSON,
    NftTrackerFromJSONTyped,
    NftTrackerToJSON,
    NftTrackerToJSONTyped,
} from './NftTracker';

/**
 * 
 * @export
 * @interface GetNftTrackerResponse
 */
export interface GetNftTrackerResponse {
    /**
     * 
     * @type {NftTracker}
     * @memberof GetNftTrackerResponse
     */
    nftTracker?: NftTracker;
    /**
     * 
     * @type {Array<NftTracker>}
     * @memberof GetNftTrackerResponse
     */
    nftTrackers?: Array<NftTracker>;
}

/**
 * Check if a given object implements the GetNftTrackerResponse interface.
 */
export function instanceOfGetNftTrackerResponse(value: object): value is GetNftTrackerResponse {
    return true;
}

export function GetNftTrackerResponseFromJSON(json: any): GetNftTrackerResponse {
    return GetNftTrackerResponseFromJSONTyped(json, false);
}

export function GetNftTrackerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNftTrackerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nftTracker': json['nftTracker'] == null ? undefined : NftTrackerFromJSON(json['nftTracker']),
        'nftTrackers': json['nftTrackers'] == null ? undefined : ((json['nftTrackers'] as Array<any>).map(NftTrackerFromJSON)),
    };
}

export function GetNftTrackerResponseToJSON(json: any): GetNftTrackerResponse {
    return GetNftTrackerResponseToJSONTyped(json, false);
}

export function GetNftTrackerResponseToJSONTyped(value?: GetNftTrackerResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nftTracker': NftTrackerToJSON(value['nftTracker']),
        'nftTrackers': value['nftTrackers'] == null ? undefined : ((value['nftTrackers'] as Array<any>).map(NftTrackerToJSON)),
    };
}

